// translations.js

export const translations = {
  en: {
    welcomeTitle: "Welcome to Asian Elite Hotel School",
    welcomeSubtitle: "THE MORE YOU LEARN,",
    welcomeSubtitle2: "THE MORE YOU CAN LEARN",
    welcomeDescription: "We offer NVQ3 and NVQ4 courses in International Cookery as well as Bakery & Patisserie with practical knowledge required for a successful career in the global hospitality industry",
    Register_on_talent_of_deliciousness: "Turn Your Passion into a Culnary Career",
    guidance_text: "Located in a vibrant urban setting, Asian Elite Hotel School combines modern facilities with experienced faculty members who bring real-world expertise to the classroom",
  },
  si: {
    welcomeTitle: "Welcome to Asian Elite Hotel School",
    welcomeSubtitle: "THE MORE YOU LEARN,",
    welcomeSubtitle2: "THE MORE YOU CAN LEARN",
    welcomeDescription: "ආගන්තුක සත්කාර කර්මාන්තයේ සාර්ථක වෘත්තියක් සඳහා අවශ්‍ය ප්‍රායෝගික දැනුම සමඟින් අප විසින් ජාත්‍යන්තර ඉවුම් පිහුම් මෙන්ම බේකරි සහ පැටිසේරි පිළිබඳ NVQ3 සහ NVQ4 පාඨමාලා පිරිනමන්නෙමු",
    Register_on_talent_of_deliciousness: "Turn Your Passion into a Culnary Career",
    guidance_text: "විචිත්‍රවත් නාගරික පසුබිමක පිහිටා ඇති Asian Elite Hotel School හි නවීන පහසුකම් සහ පළපුරුදු පීඨ සාමාජිකයින් සමඟ පන්ති කාමරයට සැබෑ විශේෂඥ දැනුම ගෙන එයි",
  },
  tam: {
    welcomeTitle: "Welcome to Asian Elite Hotel School",
    welcomeSubtitle: "THE MORE YOU LEARN,",
    welcomeSubtitle2: "THE MORE YOU CAN LEARN",
    welcomeDescription: "உலகளாவிய விருந்தோம்பல் துறையில் வெற்றிகரமான வாழ்க்கைக்குத் தேவையான நடைமுறை அறிவைக் கொண்ட சர்வதேச சமையல் மற்றும் பேக்கரி & பட்டிசீரியில் NVQ3 மற்றும் NVQ4 படிப்புகளை நாங்கள் வழங்குகிறோம்",
    Register_on_talent_of_deliciousness: "Turn Your Passion into a Culnary Career",
    guidance_text: "துடிப்பான நகர்ப்புற அமைப்பில் அமைந்துள்ள ஏசியன் எலைட் ஹோட்டல் பள்ளியில் நிஜ உலக நிபுணத்துவத்தை வகுப்பறைக்கு கொண்டு வரும் அனுபவமிக்க ஆசிரிய உறுப்பினர்களுடன் நவீன வசதிகளை ஒருங்கிணைக்கிறது",
  }
};


export const nvq_3_international_cookery = {
  BM01: "Communication skills for workplace",
  BM02: "Team Work",
  BM03: "Basic Food Costing",
  BM04: "Language literacy",
  BM05: "Occupational Health and Safety Procedures and Practice",
  BM06: "Introduction to Hotel and Catering Industry",
  M01: "Hygiene standards",
  M02: "Food Safety Standards",
  M03: "Kitchen organizational Structure",
  M04: "Time management",
  M05: "Introduction to kitchen utensils, tools and equipment",
  M06: "Food knowledge and practices",
  M07: "Cooking methods",
  M08: "Mise-en place procedures",
  M09: "Beverage preparation",
  M10: "Sandwich preparation",
  M11: "Salads & appetizers preparation",
  M12: "Stocks, Soups and Sauces preparation",
  M14: "Hot range food preparation"
};

export const nvq_4_international_cookery = {
  BM01: "Communication skills for workplace",
  BM02: "Team Work",
  BM03: "Basic Food Costing",
  BM04: "Language literacy",
  BM05: "Occupational Health and Safety Procedures and Practice",
  BM06: "Introduction to Hotel and Catering Industry",
  M01: "Hygiene standards",
  M02: "Food Safety Standards",
  M03: "Kitchen organizational Structure",
  M04: "Time management",
  M05: "Introduction to kitchen utensils, tools and equipment",
  M06: "Food knowledge and practices",
  M07: "Cooking methods",
  M08: "Mise-en place procedures",
  M09: "Beverage preparation",
  M10: "Sandwich preparation",
  M11: "Salads & appetizers preparation",
  M12: "Stocks, Soups and Sauces preparation",
  M13: "Seasoning & Marinating",
  M14: "Hot range foods preparation",
  M15: "Desserts Preparation",
  M16: "Basic ethnic food"
};

export const nvq_3_bakery = {
  M01: "Hygiene and Safety for Bakery Functions",
  M02: "Preparation of Bread and Buns",
  M03: "Preparation of Pastries",
  M04: "Preparation of Desserts",
  M05: "Preparation of Cake",
  M08: "Communication Skills for Workplace",
  M09: "Occupational Health & Safety",
  M10: "Team Work",
  M11: "Language literacy"
};

export const nvq_4_bakery = {
  M01: "Hygiene and Safety for Bakery Functions",
  M02: "Preparation of Bread and Buns",
  M03: "Preparation of Pastries",
  M04: "Preparation of Desserts",
  M05: "Preparation of Cake",
  M06: "Preparation of Cookies",
  M07: "Routine functions of a pastry and bakery",
  M08: "Communication Skills for Workplace",
  M09: "Occupational Health & Safety",
  M10: "Team Work",
  M11: "Language literacy"
};
